import React, { useEffect, useState } from "react";
import { Typography, Box, useTheme } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import { BASE_URL } from "app/services/auth-services";
import { useGetAgewiseEmployeeForAllQuery, useGetAgewiseEmployeeQuery } from "app/services/RTK_Apis/dashbords/HomeDefaultApi";

function TwoChart({ partnerName, companyId, businessUnit, isMobile }) {
  const theme = useTheme();

  const { data: agewiseAllData } =
  useGetAgewiseEmployeeForAllQuery(undefined, {
    skip: businessUnit !== "All BU",
  });

const { data: agewisePartnerData } =
  useGetAgewiseEmployeeQuery(partnerName, {
    skip: businessUnit === "All BU" || !partnerName,
  });

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "donut",
        toolbar: { show: false },
      },
      labels: [],
      colors: [],
      dataLabels: {
        enabled: true,
        style: { fontSize: "11px", fontWeight: 400 },
      },
      legend: {
        position: "bottom",
        fontSize: "11px",
        labels: { colors: theme.palette.text.primary },
        itemMargin: { horizontal: 6, vertical: 2 },
      },
      plotOptions: {
        pie: {
          donut: {
            size: "65%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Total",
                fontSize: "12px",
                color: theme.palette.text.secondary,
                formatter: (w) =>
                  w.globals.seriesTotals.reduce((a, b) => a + b, 0),
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 600,
          options: {
            chart: { width: 260 },
            legend: { position: "bottom" },
            dataLabels: { style: { fontSize: "9px" } },
          },
        },
      ],
    },
  });

  // 🎨 distinct colors
  const generateDistinctColors = (count) => {
    const baseColors = [
      "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0",
      "#9966FF", "#FF9F40", "#00C49F", "#FF8042", "#AF19FF",
    ];
    return count <= baseColors.length
      ? baseColors.slice(0, count)
      : Array.from({ length: count }, (_, i) => `hsl(${(360 / count) * i}, 70%, 55%)`);
  };

  useEffect(() => {

  const apiData =
    businessUnit === "All BU"
      ? agewiseAllData
      : agewisePartnerData;

  if (!apiData) return;

  const labels = apiData.map(
    (item) => `${item.Age} (${item.Count})`
  );

  const counts = apiData.map(
    (item) => Number(item.Count)
  );

  const colors = generateDistinctColors(counts.length);

  setChartData((prev) => ({
    ...prev,
    series: counts,
    options: {
      ...prev.options,
      labels,
      colors,
    },
  }));

}, [agewiseAllData, agewisePartnerData, businessUnit]);

  return (
    <>
      {/* <Typography variant={isMobile ? "h5" : "h4"} fontWeight={500}>Age Wise</Typography> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: { xs: 1.5, sm: 1 },
          width: "100%",
          height: "100%",
        }}
      >
        <Typography
          variant={isMobile ? "subtitle1" : "h5"}
          fontWeight={600}
          sx={{ mb: 1, textAlign: "center" }}
        >
          Age Wise
        </Typography>

        {chartData.series?.length > 0 ? (
          <Box
            sx={{
              width: "100%",
              maxWidth: isMobile ? 240 : 300,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="donut"
              width={isMobile ? 240 : 300}
              height={isMobile ? 240 : 260}
            />
          </Box>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              textAlign: "center",
              mt: 2,
            }}
          >
            Nothing to preview
          </Typography>
        )}
      </Box>
    </>
  );
}

export default TwoChart;
